import { OmniboxCtrl } from '../controllers/OmniboxCtrl';
import { Module } from '../Module';

Module.instance().directive('tbOmnibox',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'omniboxContentAnalytics.html',
      scope: {
        closed: '&',
        width: '@',
        searchOpen: '@',
      },
      controller: OmniboxCtrl
    };
  }
);
